<template>
    <b-modal
        v-model="isVisible"
        modal-class="scopes-update-wrapper vue-need-bootstrap"
        title="Update Permissions"
        lazy
        centered
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        @close="onSkipHandler"
    >
        <div class="content text-center">
            <p>Due to new updates from Shopify, Customily requieres new permissions to sync and fulfill your orders.</p>
            <ul>
                <li v-for="store of storesToUpdate" :key="store.name">
                    <a :href="store.updateUrl" rel="update scopes url">
                        {{ store.name }}
                    </a>
                </li>
            </ul>

            <button class="btn btn-primary d-block mx-auto my-3" @click="onGrantHandler">Grant Permission</button>
            <a class="skip-link" href="#" @click="onSkipHandler">Skip for now</a>
        </div>
    </b-modal>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';

const emit = defineEmits(['close']);

const props = withDefaults(
    defineProps<{
        stores?: string[];
    }>(),
    {
        stores: () => []
    }
);

const isVisible = ref(true);

const storesToUpdate = computed((): Record<string, string>[] => {
    return props.stores.map((url) => ({
        name: url,
        updateUrl: `${process.env.VUE_APP_SHOPIFY_PRODUCT_PERSONALIZER_BASE_URL}/auth/login?shop=${url}`
    }));
});

const onGrantHandler = () => {
    window.open(storesToUpdate.value[0].updateUrl);
};

const onSkipHandler = () => {
    emit('close');
};
</script>

<style scoped lang="scss">
:deep() .scopes-update-wrapper {
    .modal-header {
        text-align: center;
        background: linear-gradient(141deg, #849dd8 15%, #8bc4d3 75%);
        color: #fff;
    }
    .skip-link {
        color: unset;
        text-decoration: underline;
        font-weight: bold;
    }
}
</style>
